let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fLjHM")).then(() => parcelRequire('2qq54'));